import React from "react";
import ReactDOM from "react-dom";
import "./assets/index.scss";
import App from "./Main/App";

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);
